import { render, staticRenderFns } from "./envConfig.vue?vue&type=template&id=48b512ce&scoped=true&"
import script from "./envConfig.vue?vue&type=script&lang=ts&"
export * from "./envConfig.vue?vue&type=script&lang=ts&"
import style0 from "./envConfig.vue?vue&type=style&index=0&id=48b512ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b512ce",
  null
  
)

export default component.exports